import React from 'react';

const Tab = ({ label, isActive, onClick }) => {
  const activeClass = isActive ? 'tabs__title--active' : '';
  return (
    <li onClick={onClick} className={`tabs__title ${activeClass}`}>
      <span>{label}</span>
    </li>
  );
};

export default Tab;
